module.exports = __webpack_public_path__ + "static/media/icon-arrow-forward.c02e85e4.svg";